export default function arr_back(arr) {
    return arr[arr.length - 1];
}
